// Jira categories are authoritative, including custom statuses such as "Released".
export function isDoneJiraIssue(issue) {
  const status = issue?.fields?.status;
  const category = status?.statusCategory?.key;
  return category ? category.toLowerCase() === 'done' : /^(done|closed|resolved)$/i.test(String(status?.name || '').trim());
}

export function activeJiraJql(jql = '') {
  // Find ORDER BY outside quoted strings (a search phrase may contain those words).
  let quote = '', order = -1;
  for (let i = 0; i < jql.length; i++) {
    if (jql[i] === '\\') { i++; continue; }
    if (quote) { if (jql[i] === quote) quote = ''; continue; }
    if (jql[i] === '"' || jql[i] === "'") { quote = jql[i]; continue; }
    if (/^\border\s+by\b/i.test(jql.slice(i)) && (i === 0 || /\s/.test(jql[i - 1]))) { order = i; break; }
  }
  const filter = (order < 0 ? jql : jql.slice(0, order)).trim();
  return `${filter ? `(${filter}) AND ` : ''}statusCategory != Done${order < 0 ? '' : ` ${jql.slice(order)}`}`;
}
